<template>
  <div class="home">
    <Header />
    <Hero />
    <Services />
    <Stats />
    <Cases />
    <BrandCases />
    <News />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Hero from '@/components/Hero.vue'
import Services from '@/components/Services.vue'
import Stats from '@/components/Stats.vue'
import Cases from '@/components/Cases.vue'
import BrandCases from '@/components/BrandCases.vue'
import News from '@/components/News.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Header,
    Hero,
    Services,
    Stats,
    Cases,
    BrandCases,
    News,
    Footer
  }
}
</script>

<style scoped>
.home {
  width: 100%;
}
</style>
